import { subscribe } from '../../common/errors/sagas';
import { notificationError } from '../../common/errors/notificationTypes';

const pre = 'FILEAVAILABILITY/';

export const FILE_AVAILABILITY_CONNECTED = `${pre}FILE_AVAILABILITY_CONNECTED`;
export const GET_FILE_AVAILABILITY_SUCCESS = `${pre}GET_FILE_AVAILABILITY_SUCCESS`;
export const GET_FILE_AVAILABILITY_FAILED = `${pre}GET_FILE_AVAILABILITY_FAILED`;
export const SET_FILE_AVAILABILITY_LOADING = `${pre}SET_FILE_AVAILABILITY_LOADING`;
export const SET_INITIALISED = `${pre}SET_INITIALISED`;
export const REFRESH_FILE_AVAILABILITY = `${pre}REFRESH_FILE_AVAILABILITY`;
export const SET_GRID_SORTS = `${pre}SET_GRID_SORTS`;

subscribe(GET_FILE_AVAILABILITY_FAILED, 'There was an error retrieving the files', notificationError);

export const fileAvailabilityConnected = () => ({ type: FILE_AVAILABILITY_CONNECTED });
export const getFileAvailabilitySuccess = result => ({ type: GET_FILE_AVAILABILITY_SUCCESS, result });
export const getFileAvailabilityFailed = error => ({ type: GET_FILE_AVAILABILITY_FAILED, error });
export const setFileAvailabilityLoading = loading => ({ type: SET_FILE_AVAILABILITY_LOADING, loading });
export const setInitialised = initialised => ({ type: SET_INITIALISED, initialised });
export const refreshFileAvailability = () => ({ type: REFRESH_FILE_AVAILABILITY });
export const setGridSorts = (gridId, sorting) => ({ type: SET_GRID_SORTS, gridId, sorting });
